<!-- Main Container -->
<div class="p-6 bg-gray-50 min-h-screen">
  <!-- Header -->
  <div class="flex justify-between items-center mb-8">
    <h1 class="text-2xl font-semibold text-gray-900">{{ t('pointingAddress.title') }}</h1>
    <div class="relative left-[25%]">
      <svg class="absolute left-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
      </svg>
      <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" [placeholder]="t('pointingAddress.search')"
        class="w-full pl-10 pr-4 py-3 h-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
    </div>
    <button (click)="openCreateModal()"
      class="flex items-center gap-2 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
      style="background-color: #FF5C01;" [disabled]="isLoading">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
      </svg>
      {{ t('pointingAddress.addAddress') }}
    </button>
  </div>

  <!-- Search Bar -->
  <div class="mb-6">
    <!-- <div class="relative">
        <svg class="absolute left-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <input 
          type="text" 
          [(ngModel)]="searchTerm"
          (input)="onSearch()"
          placeholder="Rechercher une adresse..."
          class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
      </div> -->
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
    <span class="ml-2 text-gray-600">{{ t('common.loading') }}</span>
  </div>

  <!-- Table -->
  <div *ngIf="!isLoading" class="bg-white rounded-lg shadow overflow-hidden">
    <table class="w-full">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('pointingAddress.addressName') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('pointingAddress.latitude') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('pointingAddress.longitude') }}</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{
            t('pointingAddress.actions') }}</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let address of filteredAddresses" class="hover:bg-gray-50">
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="flex-shrink-0 h-10 w-10 bg-orange-100 rounded-full flex items-center justify-center">
                <svg class="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <div class="text-sm font-medium text-gray-900">{{ address.name }}</div>
              </div>
            </div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{ address.latitude }}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap">
            <div class="text-sm text-gray-900">{{ address.longitude }}</div>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <div class="flex items-center gap-2">
              <!-- Edit -->
              <button (click)="openEditModal(address)" class="text-blue-600 hover:text-blue-900" title="Modifier">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                  </path>
                </svg>
              </button>

              <!-- Delete -->
              <button (click)="deleteAddress(address)" class="text-red-600 hover:text-red-900" title="Supprimer">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                  </path>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Empty state -->
    <div *ngIf="filteredAddresses.length === 0 && !isLoading" class="text-center py-12">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z">
        </path>
      </svg>
      <p class="mt-2 text-gray-500">{{ t('pointingAddress.noAddresses') }}</p>
    </div>
  </div>
</div>

<!-- Create Modal -->
<div *ngIf="showCreateModal" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">{{ t('pointingAddress.addAddress') }}</h2>
        <button (click)="closeAllModals()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.addressName') }}</label>
          <input type="text" [(ngModel)]="newAddress.name" placeholder="Ex: Fann Hock"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>

        <!-- Bouton Géolocalisation -->
        <div>
          <button (click)="getCurrentPosition()" type="button" [disabled]="isLocating"
            class="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-200 hover:bg-blue-100 transition-colors mb-2">
            <svg *ngIf="!isLocating" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <svg *ngIf="isLocating" class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ isLocating ? t('common.processing') : t('pointingAddress.currentLocation') }}
          </button>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.latitude') }}</label>
            <input type="number" step="0.000001" [(ngModel)]="newAddress.latitude" placeholder="0.000000" readonly
              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.longitude') }}</label>
            <input type="number" step="0.000001" [(ngModel)]="newAddress.longitude" placeholder="0.000000" readonly
              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none">
          </div>
        </div>
      </div>

      <div class="flex gap-3 mt-8">
        <button (click)="createAddress()"
          [disabled]="isLoading || !newAddress.name || newAddress.latitude === 0 || newAddress.longitude === 0"
          class="flex-1 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          style="background-color: #FF5C01;">
          <span *ngIf="!isLoading">{{ t('pointingAddress.save') }}</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            {{ t('pointingAddress.saving') }}
          </span>
        </button>
        <button (click)="closeAllModals()" [disabled]="isLoading"
          class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50">
          {{ t('pointingAddress.cancel') }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div *ngIf="showDeleteModal && selectedAddress" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="text-center">
        <div class="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
            </path>
          </svg>
        </div>

        <h3 class="text-lg font-semibold mb-2">{{ t('pointingAddress.deleteConfirm') }}</h3>
        <p class="text-gray-600 mb-2">{{ t('pointingAddress.deleteConfirm') }}</p>
        <p class="text-gray-900 font-semibold mb-6">"{{ selectedAddress.name }}" ?</p>
        <p class="text-sm text-gray-500 mb-6">{{ t('statusReport.irreversibleAction') }}</p>

        <div class="flex gap-3">
          <button (click)="confirmDelete()" [disabled]="isLoading"
            class="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed">
            <span *ngIf="!isLoading">{{ t('pointingAddress.delete') }}</span>
            <span *ngIf="isLoading" class="flex items-center justify-center">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Suppression...
            </span>
          </button>
          <button (click)="closeAllModals()" [disabled]="isLoading"
            class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50">
            {{ t('pointingAddress.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div *ngIf="showEditModal && selectedAddress" class="fixed inset-0 z-50 overflow-y-auto">
  <div class="flex items-center justify-center min-h-screen px-4">
    <div class="fixed inset-0 bg-black opacity-50" (click)="closeAllModals()"></div>
    <div class="bg-white rounded-lg p-8 max-w-md w-full relative z-10">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold">{{ t('pointingAddress.editAddress') }}</h2>
        <button (click)="closeAllModals()" class="text-gray-400 hover:text-gray-600">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.addressName') }}</label>
          <input type="text" [(ngModel)]="editAddress.name" placeholder="Ex: Fann Hock"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
        </div>

        <!-- Bouton Géolocalisation pour Edit -->
        <div>
          <button (click)="getCurrentPosition()" type="button" [disabled]="isLocating"
            class="w-full flex items-center justify-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-200 hover:bg-blue-100 transition-colors mb-2">
            <svg *ngIf="!isLocating" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <svg *ngIf="isLocating" class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
              </path>
            </svg>
            {{ isLocating ? t('common.processing') : t('pointingAddress.currentLocation') }}
          </button>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.latitude') }}</label>
            <input type="number" step="0.000001" [(ngModel)]="editAddress.latitude" placeholder="0.000000" readonly
              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none">
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">{{ t('pointingAddress.longitude') }}</label>
            <input type="number" step="0.000001" [(ngModel)]="editAddress.longitude" placeholder="0.000000" readonly
              class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-500 cursor-not-allowed focus:outline-none">
          </div>
        </div>
      </div>

      <div class="flex gap-3 mt-8">
        <button (click)="updateAddress()"
          [disabled]="isLoading || !editAddress.name || editAddress.latitude === 0 || editAddress.longitude === 0"
          class="flex-1 px-4 py-2 text-white rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          style="background-color: #FF5C01;">
          <span *ngIf="!isLoading">{{ t('common.updateSave') }}</span>
          <span *ngIf="isLoading" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            {{ t('projectPresentation.updating') }}
          </span>
        </button>
        <button (click)="closeAllModals()" [disabled]="isLoading"
          class="flex-1 px-4 py-2 text-gray-700 border border-gray-300 rounded-lg font-medium hover:bg-gray-50 disabled:opacity-50">
          {{ t('pointingAddress.cancel') }}
        </button>
      </div>
    </div>
  </div>
</div>